'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _constants = require('../../../constants');

var _PlaintiffContactInfo = require('../PlaintiffContactInfo');

var _PlaintiffContactInfo2 = _interopRequireDefault(_PlaintiffContactInfo);

var _SmartBool = require('../../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _LawFirmOfficeInfo = require('./LawFirmOfficeInfo');

var _LawFirmOfficeInfo2 = _interopRequireDefault(_LawFirmOfficeInfo);

var _CaseContactsTable = require('./CaseContactsTable');

var _CaseContactsTable2 = _interopRequireDefault(_CaseContactsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CONTACT_TYPES = _constants.AppConstants.CONTACT_TYPES;
var TabContacts = (_dec = (0, _mobxReact.inject)('CaseStore', 'Clients'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(TabContacts, _Component);

  function TabContacts() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TabContacts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabContacts.__proto__ || Object.getPrototypeOf(TabContacts)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isUpdatingTrackingContact', _descriptor, _this), _initDefineProp(_this, 'trackingContactType', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TabContacts, [{
    key: 'onLawFirmModalSave',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(saveLawFirm, data) {
        var _props, CaseStore, _case, caseId, lawfirm;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props;
                CaseStore = _props.CaseStore;
                _case = _props._case;
                caseId = _case.id;
                _context.next = 6;
                return saveLawFirm({ caseId: caseId, lawfirmData: data });

              case 6:
                lawfirm = _context.sent;

                CaseStore.setLawFirm({ caseId: caseId, lawfirm: lawfirm });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onLawFirmModalSave(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return onLawFirmModalSave;
    }()
  }, {
    key: 'onRemoveLawFirmFromCase',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _props2, CaseStore, _case, caseId;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, CaseStore = _props2.CaseStore, _case = _props2._case, caseId = _case.id;
                _context2.next = 3;
                return CaseStore.update({ caseId: caseId, data: { lawfirm: null } });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onRemoveLawFirmFromCase() {
        return _ref3.apply(this, arguments);
      }

      return onRemoveLawFirmFromCase;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          _case = _props3._case,
          onPlaintiffInfoChanged = _props3.onPlaintiffInfoChanged;


      return _react2.default.createElement(
        'div',
        { className: 'case-detail-tab tab-contacts' },
        _react2.default.createElement(
          'div',
          { className: 'flex-cols-stretch' },
          _react2.default.createElement(_PlaintiffContactInfo2.default, {
            onPlaintiffInfoChanged: onPlaintiffInfoChanged,
            plaintiff: _case.plaintiff
          }),
          _react2.default.createElement(_LawFirmOfficeInfo2.default, {
            _case: _case,
            lawFirmContacts: _case.contacts.filter(function (contact) {
              return contact.contact_type === CONTACT_TYPES.LAW_FIRM.type;
            }),
            onLawFirmModalSave: this.onLawFirmModalSave,
            onRemoveLawFirmFromCase: this.onRemoveLawFirmFromCase
          })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_CaseContactsTable2.default, { _case: _case })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TabContacts;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  CaseStore: _propTypes2.default.object,
  Clients: _propTypes2.default.object,
  onPlaintiffInfoChanged: _propTypes2.default.func.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isUpdatingTrackingContact', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'trackingContactType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class) || _class) || _class);
var _default = TabContacts;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CONTACT_TYPES, 'CONTACT_TYPES', '/app/src/components/page-case/main-contacts/TabContacts.js');
  reactHotLoader.register(TabContacts, 'TabContacts', '/app/src/components/page-case/main-contacts/TabContacts.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-contacts/TabContacts.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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